import { z } from "zod";
import { metaSchema, sortBySchema } from "./commun.zod";
import { DroitSchema } from "./droit.zod";

export const ProfilBaseSchema = z.object({
  name: z.string().min(1, "Le nom est requis").max(255, "Le nom ne peut pas dépasser 255 caractères").nullable().optional(),
  is_init: z.boolean().default(false).optional(),
  groupe_type: z.string().max(255, "Le type de groupe ne peut pas dépasser 255 caractères").default("EXPERT").nullable().optional(),
  deleted: z.boolean().default(false).optional(),
  droit_id: z.number().int().positive("L'ID du droit doit être un nombre positif"),
  droit: DroitSchema
});

export const ProfilSchema = ProfilBaseSchema.extend({
  id: z.number().int().positive(),
  created_at: z.date().nullable(),
  updated_at: z.date().nullable()
});

export const ProfilCreateSchema = ProfilBaseSchema.pick({
  name: true,
  is_init: true,
  groupe_type: true,
  deleted: true,
  droit_id: true,
});

export const ProfilUpdateSchema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1, "Le nom est requis").max(255, "Le nom ne peut pas dépasser 255 caractères").nullable().optional(),
  is_init: z.boolean().optional(),
  groupe_type: z.string().max(255, "Le type de groupe ne peut pas dépasser 255 caractères").nullable().optional(),
  deleted: z.boolean().optional(),
  droit_id: z.number().int().positive("L'ID du droit doit être un nombre positif").optional(),
});

export const ProfilListResponseSchema = z.object({
  data: z.array(ProfilSchema),
  meta : metaSchema
});

export const ProfilResponseSchema = z.object({
  data: ProfilSchema,
  message: z.string().optional(),
});

export const ProfilSelectSchema = z.object({
  id: z.number().int().positive().optional(),
  limit: z.number().default(10),
  page: z.number().default(1),
  search: z.string().optional(),
  name: z.string().optional(),
  groupe_type: z.string().optional(),
  is_init: z.boolean().optional(),
  deleted: z.boolean().optional(),
  droit_id: z.number().int().positive().optional(),
  includeDeleted: z.boolean().default(false),
    sortBy: sortBySchema
});

export type Profil = z.infer<typeof ProfilSchema>;
export type ProfilCreateInput = z.infer<typeof ProfilCreateSchema>;
export type ProfilUpdateInput = z.infer<typeof ProfilUpdateSchema>;
export type ProfilSelectInput = z.infer<typeof ProfilSelectSchema>;

// Form-specific types for frontend
export type ProfilFormData = Omit<ProfilCreateInput, 'is_init' | 'deleted'> & {
  is_init?: boolean;
  deleted?: boolean;
};

export type ProfilEditFormData = Omit<ProfilUpdateInput, 'id'>;

// Utility types for different UI states
export type ProfilDisplayItem = Pick<Profil, 'id' | 'name' | 'groupe_type' | 'is_init'>;
export type ProfilSelectOption = Pick<Profil, 'id' | 'name'>;
export type ProfilTableItem = Pick<Profil, 'id' | 'name' | 'groupe_type' | 'is_init' | 'deleted' | 'created_at' | 'updated_at'>;

export type ProfilResponse = z.infer<typeof ProfilResponseSchema>;
export type ProfilListResponse = z.infer<typeof ProfilListResponseSchema>;

export const validateProfilCreate = (data: unknown) => {
  return ProfilCreateSchema.safeParse(data);
};

export const validateProfilUpdate = (data: unknown) => {
  return ProfilUpdateSchema.omit({ id: true }).safeParse(data);
};

export const validateProfilSelect = (data: unknown) => {
  return ProfilSelectSchema.safeParse(data);
};
